import "./Action.css";
import Spinner from "../icons/spinner";

const Action = ({ title, icon, onClick, loading, disabled }) => (
  <button
    className={`Action${loading ? " Action--loading" : ""}`}
    onClick={onClick}
    disabled={loading || disabled}
  >
    <span className="Action__Icon">{loading ? <Spinner /> : icon}</span>
    <span className="Action__Title">{title}</span>
  </button>
);

export default Action;
